<template functional>
  <div>
    <a href="#" @click="$options.show(props)">{{ props.row.nombre }}</a>
  </div>
</template>

<script>
//import store from "../../../../store/index";
import { formatMonto } from "@/utils";
export default {
  formatMonto,
  name: "HyperLinkForDataCliente",
  show(ops) {
    ops;
    //console.log("hola", ops)
    ops.row.OpenDetailDataCliente(ops.row);
    /*
      store.dispatch("getAllCustomer", {
        empresaid: ops.row.Empresaid
      });
      */
  }
};
</script>

<style>
.Negro {
  color: #606266;
}
</style>
